import type { CustomerArtifactItemState } from 'reducers/fileUploads';
import type { ErrorObject, Selector } from 'types';

export const getFileUploadsError: Selector<ErrorObject | null> = (state) => state.fileUploads.error;

export const getFileUploadsProgress: Selector<number | null> = (state) =>
  state.fileUploads.progress;

export const getFileUploadsSuccess: Selector<boolean> = (state) => state.fileUploads.success;

export const getFileUploadsUploading: Selector<boolean> = (state) => state.fileUploads.uploading;

export const getFileUploadsActualProvider: Selector<string | null> = (state) =>
  state.fileUploads.actualProvider;

export const getArtifactUploadItems: Selector<CustomerArtifactItemState[]> = (state) =>
  state.fileUploads.artifactItems;

export const getArtifactUploadBusy: Selector<boolean> = (state) => {
  const { artifactPhase } = state.fileUploads;
  return artifactPhase === 'presigning' || artifactPhase === 'uploading';
};

export const getArtifactPresignError: Selector<string | null> = (state) =>
  state.fileUploads.artifactPresignError;
